export default __webpack_public_path__ + "static/media/Signal.a164ab72.png";